<template>
  <v-dialog max-width="500" content-class="popular-parlays-dialog" persistent v-model="popularParlaysData">
    <div class="close-btn">
      <button @click="closePopularParlaysDialog" class="close" v-html="$t('Popular.Parlays.Close')"></button>
    </div>
    <v-card v-if="popularParlaysData && popularParlay && popularParlay.SelectionData" :data-mgid="popularParlay.IDFWMarketGroup" class="recomended-parlays" :key="popularParlay.IDFWMarketGroup">
      <popular-parlay :parlays="popularParlay"></popular-parlay>
    </v-card>
  </v-dialog>
</template>

<script>

import store from '@/store'
import BettingOffer from '@/components/mixins/BettingOffer'
import odds from './PopularParlayOdds.vue'
import handicap from './PopularParlayHcp.vue'
import PopularParlay from './PopularParlay.vue'

export default {
  name: 'PopularParlaysDialog',
  components: { odds, handicap, PopularParlay },
  mixins: [
    BettingOffer
  ],
  data () {
    return {
      parlayStake: 10
    }
  },
  computed: {
    popularParlaysDialogState () {
      return store.getters['overlayState/getPopularParlaysDialogState']
    },
    popularParlaysData () {
      return this.popularParlaysDialogState && this.popularParlaysDialogState.data
    },
    iDFWMarketGroup () {
      return this.popularParlaysDialogState && this.popularParlaysDialogState.data && this.popularParlaysDialogState.data.iDFWMarketGroup
    },
    popularParlay () {
      return (this.iDFWMarketGroup && store.getters['popularParlaysState/getPopularParlay'](this.iDFWMarketGroup)) || {}
    }
  },
  methods: {
    closePopularParlaysDialog () {
      if (this.popularParlaysDialogState && this.popularParlaysDialogState.resolve) {
        this.popularParlaysDialogState.resolve('clickX')
      } else {
        store.dispatch('overlayState/deactivatePopularParlaysDialogData', false)
      }
    }
  },
  mounted () {}
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"

>>>.popular-parlays-dialog
  border-radius var(--popular-parlays-border-radius)
  .view-more
    display none
  .close-btn
    display flex
    justify-content flex-end
    background transparent
    .close
      font-family: 'Roboto Condensed'
      font-size: 14px
      font-weight: 400
      line-height: 16.41px
      margin-right 10px
      color var(--popular-parlays-dialog-close-color)
      background var(--popular-parlays-dialog-close-bgr)
      border-top-left-radius var(--popular-parlays-border-radius)
      border-top-right-radius var(--popular-parlays-border-radius)
      width 15%
      height 30px
      display: flex
      justify-content: center
      align-items: center
  .recomended-parlays
    display flex
    width 100%
    border-radius var(--popular-parlays-border-radius)
    background transparent
    //min-height 350px
    .parlays-container.SGP
      .title-wrapper
        .sgp-title-wrapper
          display flex
          cursor pointer
          width 85%
          text-overflow ellipsis
          white-space nowrap
          overflow hidden
          font-size 15px
          font-family: 'Roboto Condensed Bold'
          line-height 17.58px
      .header-title
        display inline-block
        cursor pointer
        text-overflow ellipsis
        white-space nowrap
        overflow hidden
        font-size 15px
        font-family: 'Roboto Condensed Bold'
        line-height 17.58px
        margin-bottom 5px
        margin-left 5px
        color var(--popular-parlays-header-color)
        width 81%
        @media mobile-big-and-below
          margin-left 3px
      .sgp-icon
        display: inline-block
        background var(--betslip-sgp-icon)
        background-repeat: no-repeat
        background-size 100%
        width: var(--popular-parlay-sgp-width)
        height: var(--popular-parlay-sgp-height)
    .parlays-container.SGPPlus
      .title-wrapper
        display flex
        justify-content space-between
        .sgpplus-title-wrapper
          display flex
          cursor pointer
          width 80%
          text-overflow ellipsis
          white-space nowrap
          overflow hidden
          font-size 15px
          font-family: 'Roboto Condensed Bold'
          line-height 17.58px
          .sgp-plus-icon
            display: inline-block
            background var(--betslip-sgp-plus-icon)
            background-repeat: no-repeat
            background-size 100%
            width: var(--popular-parlay-sgp-plus-width)
            height: var(--popular-parlay-sgp-plus-height)
            margin-right: 3px
      .parlay-header
        .header-title
          margin-bottom 0
          color var(--popular-parlays-header-color) !important
      .content-wrapper
        flex 1
        background var(--popular-parlays-content-bgr)
        color var(--popular-parlays-content-color)
    .parlays-container
      width 100%
      background var(--popular-parlays-content-bgr)
      color var(--popular-parlays-content-color)
      border-radius var(--popular-parlays-border-radius)
      overflow hidden
      display flex
      flex-direction column
      .parlay-header
        .header-title
          margin-bottom 5px
      .parlay-header
        padding 5px
        border-top-left-radius var(--popular-parlays-border-radius)
        border-top-right-radius var(--popular-parlays-border-radius)
        background: var(--popular-parlays-header-bgr)
        color var(--popular-parlays-header-color)
        height 48px
        font-size 15px
        font-family: 'Roboto Condensed Bold'
        line-height 17.58px
        display flex
        flex-direction column
        justify-content flex-end
        .title-wrapper
          display flex
          justify-content space-between
        .number-of-selections
          font-size 11px
          font-family: 'Roboto Condensed'
          line-height 12.89px
          text-transform uppercase
        .title-wrapper-potential-return
          display: flex
          justify-content: space-between
      .content-wrapper
        display flex
        flex-direction column
        overflow hidden
        flex 1
        background var(--popular-parlays-content-bgr)
        color var(--popular-parlays-content-color)
        padding 10px
        .parlay-selection
          display flex
        .parlay-selection.parlay
          .content
            display flex
            border-bottom 1px solid var(--popular-parlays-content-borders-color)
            width 100%
            margin-left 5px
            justify-content space-between
            padding 5px 0 5px 0
            min-width 0
          .content-left
            padding-left 0
            min-width 0
            width 71%
          .content-right
            width 29%
        .parlay-selection.SGP
          padding 5px 0 5px 0
          .content-left
            margin-left 5px
        .parlay-selection.SGPPlus
          .content-left
            width 100%
            .sgp-selection
              display flex
              align-items: center
              //justify-content space-between
              width 100%
              .selection-data-wrapper
                display flex
                margin-bottom 5px
                justify-content space-between
                width 95%
                padding 5px 0 0 5px
                .selection-data
                  display flex
                  flex-direction column
                .potential-return
                  font-size 14px
                  line-height 18px
                  font-family: 'Roboto Condensed Bold'
                  color var(--popular-parlay-potntial-return-color)
            .SGP
              width 100%
              display flex
              //justify-content space-between
              .sgp-title
                width 95%
                display flex
                margin-bottom 5px
                padding 5px 0 0 5px
                .title-with-return.isSGP
                  .event-name
                    width 80%
                    font-size 12px
                    @media mobile-big-and-below
                      width 76%
                .title-with-return
                  display flex
                  justify-content space-between
                  width 100%
                  align-items baseline
                  font-size 14px
                  line-height 11px
                  font-family: 'Roboto Condensed Bold'
                  .event-name
                    width 100%
                    font-size 12px
                  .potential-return
                    font-size 14px
                    line-height 11px
                    font-family: 'Roboto Condensed Bold'
                    color var(--popular-parlay-potntial-return-color)
        .parlay-selection
          width 100%
          .leg-icon
            width: 13px
            height: 16px
            background-position: center
            background-repeat: no-repeat
            background-size: contain
            background-color: transparent
            background-image: var(--popular-parlay-leg-icon)
            margin-top: 0
            z-index 100
            align-self center
          .leg-icon:after
            content ''
            display block
            height 33px
            width 1px
            background transparent
            border-left var(--popular-parlay-leg-line)
            margin-left 6px
            margin-top 14px
          .content-left
            display flex
            flex-direction column
            //padding: 5px 0 0 5px
            .selection-name
              font-size 14px
              font-family: 'Roboto Condensed Bold'
              line-height 18px
              text-overflow ellipsis
              white-space nowrap
              overflow hidden
              color var(--popular-parlay-selection-color)
            .market-name
              font-size 11px
              font-family: 'Roboto Condensed'
              line-height 14px
              text-transform uppercase
              text-overflow ellipsis
              white-space nowrap
              overflow hidden
              color var(--popular-parlay-marketname-color)
            .event-name
              color var(--popular-parlay-eventname-color)
              display inline-block
              cursor pointer
              text-overflow ellipsis
              white-space nowrap
              overflow hidden
              line-height 14px
              font-family: 'Roboto Condensed Bold'
              font-size 11px
            .sgp-icon
              display: inline-block
              background var(--betslip-sgp-icon)
              background-repeat: no-repeat
              background-size 100%
              width: var(--popular-parlay-sgp-width)
              height: var(--popular-parlay-sgp-height)
              margin-right: 3px
              @media mobile-big-and-below
                min-width var(--popular-parlay-sgp-width-mobile)
                max-width var(--popular-parlay-sgp-width-mobile)
                margin-right 2px
          .content-right
            display flex
            flex-direction column
            width 30%
            justify-content: space-between
            align-items: flex-end
            //padding 5px 5px 0 0
            .potential-return
              font-size 14px
              line-height 16px
              font-family: 'Roboto Condensed Bold'
              color var(--popular-parlay-potntial-return-color)
            .start-date
              font-size 11px
              line-height 14px
              font-family: 'Roboto Condensed'
              text-transform uppercase
        .parlay-selection.parlay:last-child
          .leg-icon:after
            display none
        .parlay-selection.parlay
          .leg-icon:after
            height 45px
        .parlay-selection.SGP:last-child
          .leg-icon:after
            display none
        .parlay-selection.SGPPlus:last-child
          .content-left > *:last-child
            .leg-icon:after
              display none
  .add-to-betslip-wrapper
    display flex
    justify-content center
    padding-bottom 10px
    background var(--popular-parlays-content-bgr)
    .add-to-betslip-button
      height 42px
      width 90%
      border-radius var(--popular-parlay-primary-btn-border-radius)
      background var(--popular-parlay-primary-btn-bgr)
      color var(--popular-parlay-primary-btn-accent-color)
      border var(--popular-parlay-primary-btn-border)
      display flex
      flex-direction column
      align-items center
      justify-content center
      cursor pointer
      button
        line-height 17.58px
        font-family: 'Roboto Condensed Bold'
        font-size 15px
        cursor pointer
      p
        text-align center
        text-transform uppercase
        font-size 11px
        line-height 12.89px
        font-family: 'Roboto Condensed'
        color var(--popular-parlay-primary-btn-color)

</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/PopularParlaysDialog.vue